export enum PremiumStructure {
    Stepped = "Stepped",
    LevelTenYears = "LevelTenYears",
    LevelToAgeSixtyFive = "LevelToAgeSixtyFive",
    LevelToAgeSeventy = "LevelToAgeSeventy",
    LevelToAgeEighty = "LevelToAgeEighty",
    Unknown = "Unknown"
}
